module.exports = __webpack_public_path__ + "static/media/doctor.47d44290.jpg";